import { type FunctionalComponent, h } from '@stencil/core';

export interface IConversationalSearchSkeleton {
  itemsAmount: number;
}

export const ConversationalSearchSkeleton: FunctionalComponent<
  IConversationalSearchSkeleton
> = (props) => {
    return (
      <section class="conversational-search-skeleton">
        {Array.from({ length: props.itemsAmount }, (_, index) => (
          <div key={index} class="conversational-search-skeleton__item" />
        ))}
      </section>
    );
};
